export default "__VITE_PUBLIC_ASSET__4b864e1b__"